import { DeleteSweepRounded, FactCheckRounded, LocalShippingRounded, PrintRounded, ReceiptLongRounded, SignalCellular0Bar } from '@mui/icons-material';
import { Alert, AlertTitle, Avatar, Box, Card, Container, Fab, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemText, Switch, Table, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { green, grey } from '@mui/material/colors';
import axios from 'axios';
import { isEmpty } from 'lodash';
import { extension } from 'mime-types';
import React, { Component } from 'react';
import Dialog from '../../../common/Dialog';
import FileUpload from '../../../common/FileUpload';
import TitleWithEndAction from '../../../common/TitleWithEndAction';

class EquipementDemandBL extends Component {
    state = { 
        openSigned: false,
        demand_files : null,
        errors: {
            demand_files: ""
        }
    }

    componentDidMount = async () => {
        this.props.fetchLoanList()
    }
    setPhotos = (name, list) => {
        console.log("[INFO] SETPHOTOS", name, list);
        
        this.setState({
            [name]:list
        })
        this.props.setFiles(list)
    }
    getLoansList = () => {
        const { LOAN_LIST } = this.props;
        console.log('====================================');
        console.log({LOAN_LIST});
        console.log('====================================');
       
        // return LOAN_LIST.map( LOAN => (
        return LOAN_LIST.filter(loan => loan.loan_status != "RESA_CANCELED").map( LOAN => (
            <>
                <TableRow >
                    {this.props.DEMAND.demand_status == "DEMAND_READY" &&
                        <TableCell rowSpan={2}>
                            <Switch name={LOAN.loan_id} onChange={this.props.handleChecked} />
                        </TableCell>
                    }
                    <TableCell>
                        <img 
                            // style={{opacity: ".7"}}
                            style={{maxHeight: "150px"}}
                            src={`/photos/single/${LOAN.equipement.equipement_photo_front.filename}`} 
                            title={LOAN.equipement.equipement_original_name}
                            alt={LOAN.equipement.equipement_original_name}
                        />
                    </TableCell>
                    <TableCell> {LOAN.equipement.equipement_name} </TableCell>
                    <TableCell> {LOAN.equipement.equipement_ref} </TableCell>
                    {this.props.DEMAND.demand_status == "DEMAND_VALIDATE" &&
                        <TableCell>
                            { LOAN.loan_status == "RESA_VALIDATE" &&
                                <>
                                    <IconButton color="primary" onClick={() => this.props.handleAttributeFinal(LOAN)}>
                                        <FactCheckRounded />
                                    </IconButton>
                                    <IconButton color="error" onClick={() => this.props.handleDeleteLoan(LOAN)}>
                                        <DeleteSweepRounded />
                                    </IconButton>
                                </>
                                // || Delete ==> update RESA_CANCELED
                                // this.props.deleteLoan()
                            }
                        </TableCell>
                    }
                </TableRow> 
                { (this.props.DEMAND.demand_status == "DEMAND_READY" ||  this.props.DEMAND.demand_status == "DEMAND_PICKED_UP") &&
                    <TableRow >
                    
                    <TableCell colSpan={3}>
                        <Alert severity="warning">
                            <AlertTitle>
                                {LOAN.equipement.equipement_state_current}
                            </AlertTitle>
                            — <i>{LOAN.equipement.equipement_remarks_current}</i>
                        </Alert>
                    </TableCell>
                </TableRow> 
                }
            </>
        ))
    }

    render() {
        const { openSigned } = this.state;
        const { title, DEMAND, LOAN_LIST } = this.props;
        return (
            <Container maxWidth="md">
                <Card > 

                    <TitleWithEndAction
                        title={" "}
                    >
                        <Fab
                            color="secondary"
                            variant="contained"
                            onClick={() => window.print()}
                            size="small"
                        >
                            <PrintRounded />
                        </Fab>
                        {!isEmpty(DEMAND.demand_files) &&
                            <Fab
                                color="primary"
                                variant="contained"
                                onClick={() => this.setState({openSigned: true})}
                                size="small"
                            >
                                <ReceiptLongRounded />
                            </Fab>
                        }

                    </TitleWithEndAction>
                    {openSigned &&
                        <Dialog
                            title={title}
                            close={() => this.setState({openSigned: false})}
                            appBarColor="primary"
                            appBar
                        >
                            {DEMAND.demand_files.map(photo => 
                                <>
                                    {photo.filetype === "application/pdf" &&
                                        <Grid key={photo.filename} item xs={12} >
                                            <a href={`/photos/single/${photo.filename}`} 
                                                download={`${title}.${extension(photo.filetype) || "pdf"}`}
                                            >
                                                <embed 
                                                    src={`/photos/single/${photo.filename}`} 
                                                    width="100%" 
                                                    height="400px" 
                                                    title={title} 
                                                    type="application/pdf"
                                                />
                                            </a>
                                        </Grid>
                                    }

                                    {photo.filetype !== "application/pdf" &&
                                        <Grid key={photo.filename} item xs={6} >
                                            <a href={`/photos/single/${photo.filename}`} 
                                                download={`${title}.${extension(photo.filetype) || "jpeg"}`}
                                            >
                                                <img 
                                                    src={`/photos/single/${photo.filename}`} 
                                                    title={title} 
                                                    alt={title} 
                                                />
                                            </a>
                                        </Grid>
                                    }
                                </> 
                            )

                            }
                        </Dialog>
                    }
                    <Box p={2} id="section-to-print">
                        <Box p={2}>
                            <Typography variant="h4">
                                {title}
                            </Typography>
                        </Box>
                        <Box p={2}>
                            <Alert severity="info">
                                {DEMAND.demand_remarks}
                            </Alert>
                        </Box>
                        
                        
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>
                                <List>
                                    <ListItem >
                                        <ListItemText 
                                            primary={
                                                <Typography 
                                                    variant="body1" 
                                                    color="text.secondary" 
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                >
                                                    Date d'emprunt souhaitée :
                                                </Typography>
                                            } 
                                            secondary={
                                                <Typography variant="h6">
                                                    {new Date(DEMAND.demand_start_date).toLocaleDateString("fr-FR")}
                                                </Typography>
                                            }
                                        />                           
                                    </ListItem>
                                    <ListItem >
                                        <ListItemText 
                                            primary={
                                                <Typography 
                                                    variant="body1" 
                                                    color="text.secondary" 
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                >
                                                    Date de fin prévue :
                                                </Typography>
                                            } 
                                            secondary={
                                                <Typography 
                                                    variant="h6" 
                                                    color="text.primary" 
                                                >
                                                    {new Date(DEMAND.demand_end_date).toLocaleDateString("fr-FR")}
                                                </Typography>
                                            }
                                        />                           
                                    </ListItem>
                                    <ListItem >
                                        <ListItemText 
                                            primary={
                                                <Typography 
                                                    variant="body1" 
                                                    color="text.secondary" 
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                >
                                                    Durée:
                                                </Typography>
                                            } 
                                            secondary={
                                                <Typography 
                                                    variant="h6" 
                                                    color="text.primary" 
                                                >
                                                    {(new Date(DEMAND.demand_end_date) - new Date(DEMAND.demand_start_date))/1000/60/60/24 } jours
                                                </Typography>
                                            }
                                        />                           
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <List>
                                                        
                                    <ListItem >
                                        <ListItemText 
                                            primary={
                                                <Typography 
                                                    variant="body1" 
                                                    color="text.secondary" 
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                >
                                                    Date de préparation :
                                                </Typography>
                                            } 
                                            secondary={
                                                <Typography variant="h6">
                                                    {new Date(DEMAND.demand_ready_date).getFullYear() !== 1 ? new Date(DEMAND.demand_ready_date).toLocaleDateString("fr-FR") : "—"}
                                                </Typography>
                                            }
                                        />                           
                                    </ListItem>
                                    <ListItem >
                                        <ListItemText 
                                            primary={
                                                <Typography 
                                                    variant="body1" 
                                                    color="text.secondary" 
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                >
                                                    Date de remise :
                                                </Typography>
                                            } 
                                            secondary={
                                                <Typography 
                                                    variant="h6" 
                                                    color="text.primary" 
                                                >
                                                    {new Date(DEMAND.demand_pick_up_date).getFullYear() !== 1 ?  new Date(DEMAND.demand_pick_up_date).toLocaleDateString("fr-FR") : "—"}
                                                </Typography>
                                            }
                                        />                           
                                    </ListItem>
                                    <ListItem >
                                        <ListItemText 
                                            primary={
                                                <Typography variant="h5" color="primary">
                                                    <b>Total Articles: {this.props.totalArticles}</b>
                                                </Typography>
                                            } 
                                            // secondary={this.props.totalArticles}
                                        />                           
                                    </ListItem>
                                </List>
                            </Grid>
                        </Grid>
                        
                        <Table>
                            <TableHead>
                                <TableRow >
                                    {this.props.DEMAND.demand_status == "DEMAND_READY" &&
                                        <TableCell></TableCell>
                                    }          
                                    <TableCell>Photo</TableCell>             
                                    <TableCell>Nom</TableCell>             
                                    <TableCell>Référence</TableCell>             
                                    {this.props.DEMAND.demand_status == "DEMAND_VALIDATE" &&
                                        <TableCell>Préparer</TableCell>
                                    }          
                                </TableRow>
                            </TableHead>
                            {!isEmpty(LOAN_LIST) && 
                                this.getLoansList()
                            }
                        </Table>
                    </Box>

                    <Box p={2} >
                        {DEMAND.demand_status == "DEMAND_READY" &&
                        <FileUpload
                            fullWidth 
                            setFiles={(pic) => this.setPhotos("demand_files", pic)} 
                            files={this.state.demand_files || []}
                            label="Etat de remise" 
                        />
                    }
                        
                    </Box>


                </Card>
            </Container>
        );
    }
}

export default EquipementDemandBL;